<script lang="ts">
	import ScoringESG from '../../scoring-esg/ScoringESG.svelte';
	import type { OperationModel } from '../../../models/api/OperationModel';
	import { capitalize } from '$lib/utils/strings';
	import { t } from 'svelte-i18n';

	export let operation: OperationModel;
</script>

{#if operation.environmentScore && operation.socialScore && operation.governanceScore}
	<section>
		<h2>{capitalize($t('operation.scoringESG.title'))}</h2>
		<ScoringESG
			props={{
				valueEnergyTransition: operation.environmentScore,
				valueSocial: operation.socialScore,
				valueGovernance: operation.governanceScore
			}}
		/>
	</section>
{/if}
